import { render, staticRenderFns } from "./signFlowList.vue?vue&type=template&id=31ed5b99&scoped=true&"
import script from "./signFlowList.vue?vue&type=script&lang=js&"
export * from "./signFlowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed5b99",
  null
  
)

export default component.exports